const state = {
  // 端口值
  client_type: '',
  // 订单信息
  order_detail: {
    city_id: '',
    area_id: '',
    cost_type: '',
    discount_amount: '',
    pay_type: '',
    order_vehicle_id: '',
    move_package_id: '',
    phone: '',
    order_contact_phone: '',
    order_send_type: '',
    order_time: ''
  },
  // 风控参数
  risk_params: {
    lat: '', // 设备纬度
    lon: '', // 设备经度

    uuid: '', // ios设备标识
    imei: '', // 安卓设备标识
    open_id: '', // 小程序open_id
    push_cid: '', // 个推和⼚厂商推送cid

    nettype: '', // 网络类型 WI-FI 2G 3G 4G 5G
    bssid: '', // WiFi-MAC
    ssid: '', // WIFI名称

    brand: '', // 手机品牌

    os_type: '', // int 1:android 2:ios 3:windows 4:macos
    model: '', // 手机型号
    osversion: '', // 手机系统版本

    mac: '', // 手机-MAC  暂时不用传
    device_sign: '', // 设备指纹 暂时不用传
    appversion: '', // 用户端版本号
    app_key: '', // 开发者标识
    out_user_id: '' // 外部平台进来的用户唯一标识（如：银联）
  }
};

const getters = {};

const actions = {};

const mutations = {
  saveClientType(state, clientType) {
    state.client_type = clientType;
  },
  savaOrderDetail(state, orderInfo) {
    state.order_detail = orderInfo;
  },
  savaRiskParams(state, riskParams) {
    state.risk_params = riskParams;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
